import { useState, useEffect } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { ReactComponent as ErrorIcon } from "@/assets/icons/error.svg";
import "./Payment.css";

const PaymentError: React.FC = () => {
  const [searchParams] = useSearchParams();
  const shoppingCartID = searchParams.get("ShoppingCartID");

  const [timeoutElapsed, setTimeoutElapsed] = useState(false);

  useEffect(() => {
    if (!shoppingCartID) {
      return;
    }

    setTimeout(() => {
      setTimeoutElapsed(true);
    }, 3000);
  }, []);

  if (!shoppingCartID || timeoutElapsed) {
    return <Navigate to="/cart" replace />;
  }
  return (
    <div className="payment-container">
      <div className="payment-card">
        <div className="payment-content">
          <div className="flex justify-center">
            <ErrorIcon />
          </div>
          <div className="text-[#0b1a29] text-center text-xl font-bold">
            Plaćanje neuspješno!
          </div>
          <div className="text-center">
            Preusmjeravanje natrag na aplikaciju...
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentError;
